import React, { useEffect, useState, useContext } from "react";
import { Card, CardHeader, CardHeaderToolbar, CardBody } from "../../../../_metronic/_partials/controls";
import { Button, Spinner } from "react-bootstrap";
import { PreInscripcionUIConsumer, PreInscripcionUIContext } from "./PreInscripcionUIContext";

import PreInscripcionPasos from './PreInscripcionPasos';

//COMPONENTES REUTILIZABLES GLOBALES
import MesaAyuda from '../../Comun/Cards/MesaAyuda';
import SnackBarCustom from '../../Comun/SnackBars/SnackBarCustom';

import { useDispatch, shallowEqual, useSelector } from "react-redux";
import * as actionsInscripcion from "./_redux/inscripcion/inscripcionActions";
import * as actionsAspirante from "./_redux/aspirante/aspiranteActions";
//import * as actionsEstablecimientos from "./_redux/establecimiento/establecimientoActions";
import * as actionsPasoUno from "./_redux/pasoUno/pasoUnoActions";
import * as actionsPasoDos from "./_redux/pasoDos/pasoDosActions";
import * as actionsPasoTres from "./_redux/pasoTres/pasoTresActions";
import * as actionsPasoCuatro from "./_redux/pasoCuatro/pasoCuatroActions";
import * as actionsPasoCinco from "./_redux/pasoCinco/pasoCincoActions";
import * as _ from "lodash";

import moment from 'moment';

import CardInscripcion from './components/CardInscripcion';


//FECHA HOY
const hoy = moment();
const cierre = moment(process.env.REACT_APP_FECHA_CIERRE);

export const PreInscripcionCard = () => {
  const { dispatchDatosPeronales } = useContext(PreInscripcionUIContext);
  const [home, setHome] = useState(true);
  const [deshacerInscripcionId, sertDeshacerInscripcionId] = useState(0);

  const { inscripcion } = useSelector(
    (state) => ({ inscripcion: state.inscripcion }),
    shallowEqual
  );

  const { llamado } = useSelector(
    (state) => ({ llamado: state.llamado }),
    shallowEqual
  );

  const {
    entities: inscripciones,
    listLoading,
    actionsLoading,
    error
  } = inscripcion;

  const {
    entities: llamados,
    listLoading: listLoadingLlamados,
    errorLlamados
  } = llamado;

  useEffect(() => {
    if (deshacerInscripcionId > 0) {
      let inscripcionDeshecha = _.filter(inscripciones, ['id', deshacerInscripcionId]);

      if (!actionsLoading && !error && !inscripcionDeshecha) {
        sertDeshacerInscripcionId(0);
      } else {
        if (error) {
          sertDeshacerInscripcionId(0);
        };
      };
    };
  }, [actionsLoading, inscripciones, error, deshacerInscripcionId])

  const dispatch = useDispatch();

  function cargarAspiranteAsync(id) {
    dispatch(actionsAspirante.fetchAspiranteInformacionFromId(id));
    setTimeout(() => {
      setHome(false);
    }, 600);
  };

  function limpiarContenido() {
    dispatch(actionsAspirante.stateLimpiar());
    //dispatch(actionsEstablecimientos.stateLimpiar());
    dispatch(actionsPasoUno.stateLimpiar());
    dispatch(actionsPasoDos.stateLimpiar());
    dispatch(actionsPasoTres.stateLimpiar());
    dispatch(actionsPasoCuatro.stateLimpiar());
    dispatch(actionsPasoCinco.stateLimpiar());
    dispatchDatosPeronales({ type: 'reiniciarDatos' });
  };

  function descartarInscripcion(inscripcionId) {
    dispatch(actionsInscripcion.fetchDescartarInscripcion(inscripcionId));
    sertDeshacerInscripcionId(inscripcionId);
  };

  useEffect(() => {
    if (home) {
      dispatch(actionsInscripcion.fetchInscripciones());
      dispatch(actionsInscripcion.fetchLlamados());
    };
  }, [home,dispatch]);

  const llamadosActivos = llamados && _.filter(llamados, function(o) { 
                              return moment().isBetween(moment(o.desde), moment(o.hasta)); 
                            });

  return (
    <>
      <Card>
        <CardHeader title={home ? "Bienvenido" : "Inscripción Online"}>
          {!home &&
            <CardHeaderToolbar>
              <Button size="sm" variant="outline-success" className="p-1 pl-5 pr-5" disabled={listLoading}
                onClick={() => {
                  limpiarContenido();
                  setHome(true);
                }}
              > Inicio </Button>
            </CardHeaderToolbar>
          }
        </CardHeader>
        <CardBody>
          {home ?
            <>
              {error && (<SnackBarCustom tipo="error" mensaje={error} />)}
              {errorLlamados && (<SnackBarCustom tipo="error" mensaje={errorLlamados} />)}

              {listLoadingLlamados ?
                <div className="text-success font-weight-bold text-center mb-4">
                  <Spinner animation="border" variant="success" />
                </div>
                :
                (!!llamadosActivos && llamadosActivos.length > 0) ? 
                  <>
                    <p>Aquí podrá realizar la inscripción de su tutelado para el Ciclo Lectivo {llamadosActivos[0].cicloLectivo}</p>
                    <p>Inscripciones online se encuentra habilitado para los siguientes niveles</p>
                    <ul>
                      {llamadosActivos.map((nivel, index) => (
                        <li key={index.toString()}>Nivel <b>{nivel.nivelEnsenanza}</b> hasta el {moment(nivel.hasta).format('DD-MM-YYYY')}</li>
                      ))}
                    </ul>
                    <div className="row justify-content-center mb-3 mt-15">
                      <Button size="sm" variant="success" className="p-1 pl-5 pr-5"
                        onClick={() => {
                          limpiarContenido();
                          setHome(false);
                        }}
                      >
                        Nueva Inscripción
                        </Button>
                    </div>
                  </>
                  :
                  <>
                    <p>Aún no se ha habilitado el proceso de incripciones online.</p>
                  </>
              }
              
              <PreInscripcionUIConsumer>
                {(value) =>
                  <>
                    {listLoading ?
                      !listLoadingLlamados && (
                        <div className="text-success font-weight-bold text-center mb-4">
                          <Spinner animation="border" variant="success" />
                        </div>
                      )
                      :
                      value.cantidadInscripciones() > 0 && (
                        <>
                          <p>Estas son tus inscripciones hasta el momento</p>
                          {_.orderBy(Object.keys(value.verInscripcionesPorLlamado()), function (o) { return parseInt(o) }, 'desc')
                            .map((llamado, i) => {
                              return (
                                <div key={i}>
                                  <div className="row">
                                    <div className="col-md-12">
                                      <h4>{llamado && llamado != 'null' ? `${llamado}º Llamado` : 'Inscripciones sin nivel asignado'}</h4>
                                    </div>
                                  </div>
                                  <div className="row justify-content-center">
                                    {value.verInscripcionesPorLlamado()[llamado].map((item, x) =>
                                      <div className="col-10 col-sm-8 col-md-6 col-lg-5 col-xl-4 p-4" key={x}>
                                        <CardInscripcion
                                          llamadosActivos={llamadosActivos}
                                          item={item}
                                          limpiarContenido={limpiarContenido}
                                          cargarAspiranteAsync={cargarAspiranteAsync}
                                          descartarInscripcion={descartarInscripcion}
                                        />
                                      </div>
                                    )}
                                  </div>
                                </div>
                              )
                            })
                          }
                        </>
                      )
                    }
                    {!listLoading && value.cantidadInscripciones() === 0 &&
                      <div className="text-success font-weight-bold text-center mb-4">Usted no posee inscripciones registradas</div>
                    }
                  </>
                }
              </PreInscripcionUIConsumer>
            </>
            :
            <>
              {(!!llamadosActivos && llamadosActivos.length > 0) &&
                <PreInscripcionPasos setHome={setHome} limpiarContenido={limpiarContenido} />
              }
            </>
          }
        </CardBody>
      </Card>
      <MesaAyuda />
    </>
  );
};